import React, { useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/navbar2.js";
import EditCompanyProfile2 from "./new_pages/company_profile/edit_company_profile.js";
import Role from "./new_pages/roles/role.js";
import RedirectRole from "./new_pages/roles/redirect_role.js";
import NewRolePage from './new_pages/roles/NewRolePage'; 
import BasicInformation from './new_pages/roles/create/BasicInformation';
import RecordSpotlight from './new_pages/roles/create/RecordSpotlight';
import VideoRecording from './new_pages/roles/create/VideoRecording';
import JobDescription from './new_pages/roles/create/JobDescription';
import ReviewRole from './new_pages/roles/create/ReviewRole';
import BookWithJumpstart from './new_pages/roles/create/BookWithJumpstart';
import SpotlightSelection from './new_pages/roles/create/SpotlightSelection'
import InternalRecommendations from './new_pages/internal/InternalRecommendations';
import InternalUserManagement from './new_pages/admin/InternalUserManagement';

import Roles from "./pages/roles/roles.js";
import Roles2 from "./new_pages/roles/roles.js";
import Roles3 from "./new_pages/roles/roles2.js";
import CreateRole from "./new_pages/roles/create_role.js";
import Login from "./pages/login.js";
import NotFound from "./pages/not_found";
import Candidate from "./new_pages/candidates/candidate2.js";
import EditRole from "./new_pages/roles/edit_role.js";
import Browse from "./new_pages/candidates/browse/browse-test.js";
import JumpstartPreview from "./new_pages/candidates/browse/jumpstart-preview.js";
import InterviewRequest from "./pages/interviews/interview_request.js";
import Shortlists from "./new_pages/candidates/shortlist/shortlists.js";
import Shortlists2 from "./new_pages/candidates/shortlist/shortlists2.js";
import Shortlist from "./new_pages/candidates/shortlist/shortlist.js";
import Shortlist2 from "./new_pages/candidates/shortlist/shortlist2.js";

import RequestInterview from "./pages/shortlists/request_interview.js";
import RequestInterview2 from "./new_pages/candidates/shortlist/request_interview.js";
import NewRequestInterview from "./new_pages/candidates/shortlist/new_request_interview.js";

import { ShortlistedProvider } from "./provider/ShortlistedContext.js";
import { ApplicationsProvider } from "./provider/ApplicationsContext.js";
import ApplicationNotification from "./components/notifications/ApplicationNotification.js";
import FakeLogin from "./pages/fake_login.js";
import Applications from "./new_pages/applications/applications.js";
import Requests from "./new_pages/interviews/requests.js";
import InProcess from "./new_pages/interviews/in_process.js";
import Declined from "./new_pages/interviews/declined.js";
import Onboarding2 from "./new_pages/onboarding/new_onboarding.js";
import RequestInterviewStreamlined from "./new_pages/candidates/shortlist/request_interview_streamlined.js";
import OpenAIRequestComponent from "./new_pages/onboarding/quick_create.js";
import Home from "./new_pages/home/home.js";
import ApplicationForm from "./candidates_pages/applications/application_form.js";
import RolesList from "./candidates_pages/roles/roles.js";
import NewRole from "./new_pages/roles/new_role.js";
import NewOnboarding from "./new_pages/onboarding/custom_onboarding.js";
import useGoogleAnalytics from "./useGoogleAnalytics"; // Import the custom hook
import CandidatesPreview from "./new_pages/candidates/candidates_preview.js";
import RoleCreated from "./new_pages/roles/congrats_screen.js";
import CongratsScreen from "./new_pages/onboarding/in_between_screen.js";
import JSPreview from "./new_pages/candidates/js_preview.js";
import TestSWE from "./new_pages/test_swe.js";
import CandidatesOfTheWeek from "./new_pages/candidates/candidates_of_the_week.js";

import PasswordlessLogin from "./pages/passwordless-login.js";
import MagicLinkVerify from "./pages/auth/verify.js";
import PasswordlessDashboard from "./pages/passwordless-dashboard.js";
import PasswordlessAuthWrapper from "./components/PasswordlessAuthWrapper.js";
import TestMagicLinks from "./pages/test-magic-links";
import AuthGuard from "./components/AuthGuard";
import BrowseTest from "./new_pages/candidates/browse/browse-test";

function App() {
  useGoogleAnalytics(); // Use the custom hook for tracking page views
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  // Listen for window resize events to update isMobile state
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const noNavbarPaths = [
    "/role",
    "/",
    "/signin",
    "/passwordless-login",
    "/auth/verify",
    "/interview-request",
    "/application-form",
    "/roles-list",
    "/new-role2",
    "/new-onboarding",
    "/error",
    "/role-created",
    "/account-created",
    "/jumpstart-preview",
    "/create-role/basic-info",
    "/create-role/spotlight",
    "/create-role/record",
    "/create-role/job-description",
    "/create-role/review",
    "/create-role/book-jumpstart",
    "/create-role/spotlights",
    "/create-role/select-spotlight",
    "/internal-recommendations",
    "/admin/user-management",
    "/alt-signin",

    "*", // Ensure NotFound page does not show the navbar
  ]; // Add paths where you don't want the navbar

  // Don't show notification on applications page
  const showNotification = location.pathname !== "/applications" && 
                          location.pathname !== "/signin" && 
                          location.pathname !== "/alt-signin" && 
                          location.pathname !== "/passwordless-login" &&
                          location.pathname !== "/auth/verify" &&
                          location.pathname !== "/";
  
  // Check if the current path should have navbar using startsWith to handle paths with query params
  const shouldHideNavbar = () => {
    // Hide navbar on browse-candidates pages in mobile view
    // if (isMobile && 
    //     (location.pathname === '/browse-candidates' || 
    //      location.pathname.startsWith('/browse-candidates-recommendation'))) {
    //   return true;
    // }
    
    // Handle exact matches first
    if (noNavbarPaths.includes(location.pathname)) {
      return true;
    }
    
    // Special handling for jumpstart-preview with query parameters
    if (location.pathname.startsWith('/jumpstart-preview') && location.search !== '') {
      return true;
    }
    
    // Handle exact paths with query parameters
    if (location.pathname === '/role' && location.search !== '') {
      return true;
    }
    
    // Special handling for other paths that need query param support (using exact path match)
    const pathsWithParamSupport = [
      '/role-created',
      '/account-created', 
      '/signin',
    ];
    
    return pathsWithParamSupport.some(path => location.pathname === path && location.search !== '');
  };

  return (
    <div className="App">
      <ShortlistedProvider>
        <ApplicationsProvider>
          <div className="content bg-gray-100 h-full">
            {!shouldHideNavbar() && <Navbar hideVisualHeaderOnMobile={isMobile && (location.pathname === '/browse-candidates' || location.pathname.startsWith('/browse-candidates-recommendation'))} />}

            <Routes>
              <Route path="/" element={<FakeLogin />} />
              <Route path="/signin" element={<Login />} />
              <Route path="/alt-signin" element={<Navigate to="/passwordless-login" replace />} />
              <Route path="/passwordless-login" element={<PasswordlessLogin />} />
              <Route path="/auth/verify" element={<MagicLinkVerify />} />
              <Route path="/passwordless-dashboard" element={
                <PasswordlessAuthWrapper>
                  <PasswordlessDashboard />
                </PasswordlessAuthWrapper>
              } />
              <Route path="/test-magic-links" element={<TestMagicLinks />} />
              <Route path="/home" element={<Home />} />
              <Route path="/browse-candidates" element={<Browse />} />
              <Route path="/candidates-of-the-week" element={<AuthGuard><CandidatesOfTheWeek /></AuthGuard>} />
              <Route path="/browse-candidates-recommendation/:roleId" element={<Browse/>} />
              <Route path="/jumpstart-preview" element={<JumpstartPreview />} />
              <Route path="/internal-recommendations" element={<InternalRecommendations />} />
              <Route path="/admin/user-management" element={
                <PasswordlessAuthWrapper>
                  <InternalUserManagement />
                </PasswordlessAuthWrapper>
              } />

              <Route path="/shortlists2" element={<Shortlists />} />
              <Route path="/shortlist2" element={<Shortlist />} />
              <Route path="/shortlist" element={<Shortlist2 />} />
              <Route path="/test-new-role" element={<NewRolePage />} />

              <Route path="/shortlists" element={<AuthGuard><Shortlists2 /></AuthGuard>} />
              <Route path="/request-interview2/" element={<RequestInterview />} />
              <Route path="/starred-candidates" element={<AuthGuard><CandidatesOfTheWeek /></AuthGuard>} />
              <Route path="/request-interview" element={<RequestInterview2 />} />
              <Route
                path="/request-interview-streamlined"
                element={<RequestInterviewStreamlined />}
              
              />
              <Route path="/role" element={<Role />} />
              <Route path="/role/:id" element={<RedirectRole />} />
              <Route path="/company-profile" element={<EditCompanyProfile2 />} />
              <Route path="/new-role" element={<CreateRole />} />

              <Route path="/create-role/select-spotlight" element={<SpotlightSelection />} />
              <Route path="/create-role/book-jumpstart" element={<BookWithJumpstart />} />
              <Route path="/create-role/basic-info" element={<BasicInformation />} />
              <Route path="/create-role/spotlight" element={<RecordSpotlight />} />
              <Route path="/create-role/record" element={<VideoRecording />} />
              <Route path="/create-role/job-description" element={<JobDescription />} />
              <Route path="/create-role/review" element={<ReviewRole />} />

              <Route path="/new-role2" element={<NewRole />} />
              <Route path="/applications" element={<AuthGuard><Applications /></AuthGuard>} />
              <Route path="/requests" element={<Requests />} />
              <Route path="/in-process" element={<InProcess />} />
              <Route path="/declined" element={<Declined />} />
              <Route path="/onboarding2" element={<Onboarding2 />} />
              <Route path="/new-onboarding" element={<AuthGuard><NewOnboarding /></AuthGuard>} />
              <Route path="/quick-create" element={<OpenAIRequestComponent />} />
              <Route path="/candidates-preview" element={<CandidatesPreview />} />

              <Route path="*" element={<NotFound />} />
              <Route path="/error" element={<NotFound />} />
              <Route path="/interview-request" element={<InterviewRequest />} />
              <Route path="/roles" element={<AuthGuard><Roles3 /></AuthGuard>} />

              <Route path="/candidate/:id" element={<AuthGuard><Candidate /></AuthGuard>} />
              <Route path="/edit-role" element={<EditRole />} />

              <Route path="/candidate2/:id" element={<Candidate />} />
              <Route path="/roles2" element={<Roles />} />
              <Route path="/role" element={<Role />} />
              <Route path="/role-created" element={<RoleCreated />} />
              <Route path="/account-created" element={<CongratsScreen />} />

              <Route path="/application-form" element={<ApplicationForm />} />
              <Route path="/roles-list" element={<RolesList />} />

              <Route path="/test-swe" element={<TestSWE />} />
              <Route
                path="/new-request-interview"
                element={<NewRequestInterview />}
              />
            </Routes>
            
            {/* Show notification based on path */}
            {showNotification && <ApplicationNotification />}
          </div>
        </ApplicationsProvider>
      </ShortlistedProvider>
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
